import { render } from "./ProAvulsosporCestasView.vue?vue&type=template&id=158e7041&scoped=true"
import script from "./ProAvulsosporCestasView.vue?vue&type=script&lang=js"
export * from "./ProAvulsosporCestasView.vue?vue&type=script&lang=js"

import "./ProAvulsosporCestasView.vue?vue&type=style&index=0&id=158e7041&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158e7041"]])

export default __exports__